import { AsyncData } from '@shared/interfaces/asyncData';
import { RootState } from '../store';
import { DepartmentData } from '@shared/interfaces/DepartmentData';

export const selectAllDepartments = (state: RootState): AsyncData<DepartmentData[]> => state.departments.allDepartments;
export const selectHiddenDepartments = (state: RootState): AsyncData<string[]> => state.departments.hiddenDepartments;
